import { Injectable } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { SlideCardInterface } from '../../component-lib/components/slide-card/slide-card.interface';
import { ChargingIntroductionModel, IntroductionType } from './introduction.model';

@Injectable()
export class ChargingIntroductionMapper {
  public map(type: IntroductionType): ChargingIntroductionModel {
    return {
      items: this.getItems(type),
    };
  }

  private getItems(type: IntroductionType): SlideCardInterface[] {
    const slidesLength = type === IntroductionType.skipIntroChargingStation ? 4 : 3;
    const slides = {
      [IntroductionType.skipIntroChargingStation]: [
        {
          src: `./assets/evsb/img/charging-station/intro-1.svg`,
          step: `1/${slidesLength}`,
          title: marker(`modules.evsb.chargingStation.intro.1.title`),
          text: marker(`modules.evsb.chargingStation.intro.1.text`),
        },
        {
          src: `./assets/evsb/img/charging-station/intro-2.gif`,
          step: `2/${slidesLength}`,
          title: marker(`modules.evsb.chargingStation.intro.2.title`),
          text: marker(`modules.evsb.chargingStation.intro.2.text`),
        },
        {
          src: `./assets/evsb/img/charging-station/intro-3.svg`,
          step: `3/${slidesLength}`,
          title: marker(`modules.evsb.chargingStation.intro.3.title`),
          text: marker(`modules.evsb.chargingStation.intro.3.text`),
        },
        {
          src: `./assets/evsb/img/charging-station/intro-4.gif`,
          step: `4/${slidesLength}`,
          title: marker(`modules.evsb.chargingStation.intro.4.title`),
          text: marker(`modules.evsb.chargingStation.intro.4.text`),
        },
      ],
      [IntroductionType.skipIntroChargingCard]: [
        {
          src: `./assets/evsb/img/charging-card/intro-1.svg`,
          step: `1/${slidesLength}`,
          title: marker(`modules.evsb.chargingCard.intro.1.title`),
          text: marker(`modules.evsb.chargingCard.intro.1.text`),
        },
        {
          src: `./assets/evsb/img/charging-card/intro-2.svg`,
          step: `2/${slidesLength}`,
          title: marker(`modules.evsb.chargingCard.intro.2.title`),
          text: marker(`modules.evsb.chargingCard.intro.2.text`),
        },
        {
          src: `./assets/evsb/img/charging-card/intro-3.svg`,
          step: `3/${slidesLength}`,
          title: marker(`modules.evsb.chargingCard.intro.3.title`),
          text: marker(`modules.evsb.chargingCard.intro.3.text`),
        },
      ],
    };
    return slides[type];
  }
}
